import { createAction, props } from '@ngrx/store';
import { ProjektDaten } from '../../components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';

export const loadProjektStart = createAction('ZEIT::PROJECTS_LOAD_START');
export const loadProjektSucceeded = createAction('ZEIT::PROJECTS_LOAD_SUCCEEDED',
  props<{ projektDaten: ProjektDaten[] }>(),
);
export const loadProjektFailed = createAction('ZEIT::PROJECTS_LOAD_FAILED');
